<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

import MainInfoTutor from './main-info/MainInfoTutor.vue'
import MainInfoEmail from './main-info/MainInfoEmail.vue'
import MainInfoAttendanceRate from './main-info/MainInfoAttendanceRate.vue'
import MainInfoAssignLimit from './main-info/MainInfoAssignLimit.vue'
import MainInfoCategory from './main-info/MainInfoCategory.vue'
import MainInfoPaidLabel from './main-info/MainInfoPaidLabel.vue'
import MainInfoVideoRecordings from './main-info/MainInfoVideoRecordings.vue'
import MainInfoPremium from './main-info/MainInfoPremium.vue'

defineOptions({
  name: 'TutorKanbanMainInfo',
})
</script>

<template>
  <div class="tutor-info">
    <AppText name="body1-medium">
      Tutor info
    </AppText>
    <div class="tutor-info__wrapper">
      <div class="tutor-info__column">
        <MainInfoTutor />
        <MainInfoEmail />
        <MainInfoAttendanceRate />
        <MainInfoVideoRecordings />
      </div>
      <div class="tutor-info__column">
        <MainInfoCategory />
        <MainInfoPaidLabel />
        <MainInfoAssignLimit />
        <MainInfoPremium />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./TutorKanbanMainInfo.scss" />
